
export const facultyData = [
  {
    name: "Dr. Anjali Sharma",
    specialization: "Agri Sciences",
    experience: "4 years",
    qualification: "B.tech",
    bio: "Expert in sustainable farming with 20+ research papers"
  },
  {
    name: "Mr. Ravi Mehta",
    specialization: "IT & Analytics",
    experience: "2 years",
    qualification: "MCA",
    bio: " engineer specializing in data science and cloud"
  },
  {
    name: "Ms. Priya Nair",
    specialization: "Para-medical",
    experience: "5 years",
    qualification: "M.Sc.",
    bio: "Senior lab instructor with expertise in clinical pathology"
  },
  {
    name: "Mr. Suresh Reddy",
    specialization: "Govt. Exams",
    experience: "7 years",
    qualification: "M.A., JNU",
    bio: "Author of 5 bestsellers for competitive exam preparation"
  }
];